const initialState = {
  appCustomers: [],
  loading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  error: null,
  pageCount: 0,
  total: 0,
  stats: null,
  statsLoading: false,
  // Bumped on every CRUD success so the stats cards refetch.
  statsVersion: 0,
  mapCustomers: [],
  mapLoading: false,
  // Espace clients filter bar (admin: organization + affiliate, affiliate:
  // one of its organizations). Every Espace clients fetch sends it.
  scope: { organizationId: null, businessAffiliateId: null },
};

const appCustomersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SET_APP_CUSTOMERS_SCOPE":
      return { ...state, scope: { ...state.scope, ...payload } };

    case "FETCH_APP_CUSTOMERS_LOADING":
      return { ...state, loading: true, error: null };

    case "FETCH_APP_CUSTOMERS_SUCCESS":
      return {
        ...state,
        loading: false,
        appCustomers: payload.data || [],
        pageCount: payload.meta?.pagination?.pageCount || 0,
        total: payload.meta?.pagination?.total || 0,
        error: null,
      };

    case "FETCH_APP_CUSTOMERS_LOAD_MORE_SUCCESS":
      return {
        ...state,
        loading: false,
        appCustomers: [...state.appCustomers, ...(payload.data || [])],
        pageCount: payload.meta?.pagination?.pageCount || 0,
        total: payload.meta?.pagination?.total || 0,
        error: null,
      };

    case "FETCH_APP_CUSTOMERS_ERROR":
      return { ...state, loading: false, error: payload };

    case "CREATE_APP_CUSTOMER_LOADING":
      return { ...state, createLoading: true };

    case "CREATE_APP_CUSTOMER_SUCCESS":
      return {
        ...state,
        createLoading: false,
        appCustomers: [payload, ...state.appCustomers],
        total: state.total + 1,
        statsVersion: state.statsVersion + 1,
      };

    case "CREATE_APP_CUSTOMER_ERROR":
      return { ...state, createLoading: false };

    case "UPDATE_APP_CUSTOMER_LOADING":
      return { ...state, updateLoading: true };

    case "UPDATE_APP_CUSTOMER_SUCCESS":
      return {
        ...state,
        updateLoading: false,
        // Client list rows keep their order figures (not in the PUT reply).
        appCustomers: state.appCustomers.map((customer) =>
          customer?.id === payload?.id
            ? { ...payload, clientOrder: customer.clientOrder }
            : customer
        ),
        statsVersion: state.statsVersion + 1,
      };

    case "UPDATE_APP_CUSTOMER_ERROR":
      return { ...state, updateLoading: false };

    case "DELETE_APP_CUSTOMER_LOADING":
      return { ...state, deleteLoading: true };

    case "DELETE_APP_CUSTOMER_SUCCESS":
      return {
        ...state,
        deleteLoading: false,
        appCustomers: state.appCustomers.filter(
          (customer) => `${customer?.id}` !== `${payload}`
        ),
        total: Math.max(state.total - 1, 0),
        statsVersion: state.statsVersion + 1,
      };

    case "DELETE_APP_CUSTOMER_ERROR":
      return { ...state, deleteLoading: false };

    case "FETCH_APP_CUSTOMERS_MAP_LOADING":
      return { ...state, mapLoading: true };

    case "FETCH_APP_CUSTOMERS_MAP_SUCCESS":
      return { ...state, mapLoading: false, mapCustomers: payload };

    case "FETCH_APP_CUSTOMERS_MAP_ERROR":
      return { ...state, mapLoading: false };

    case "FETCH_APP_CUSTOMER_STATS_LOADING":
      return { ...state, statsLoading: true };

    case "FETCH_APP_CUSTOMER_STATS_SUCCESS":
      return { ...state, statsLoading: false, stats: payload };

    case "FETCH_APP_CUSTOMER_STATS_ERROR":
      return { ...state, statsLoading: false };

    default:
      return state;
  }
};

export default appCustomersReducer;
